import React from 'react';

const MenuLinesIcon = ({ width = 24, height = 24, stroke = '#000000', ...props }) => {
    return (
        <svg
          width={width}
          height={height}
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <path
            d="M5 17H19M5 12H19M5 7H19"
            stroke={stroke}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
};

export default MenuLinesIcon;
